module.exports = " <div class=scrollbar _v-29212bf6=\"\"> <div class=mdl-card__title _v-29212bf6=\"\"> <h4 class=mdl-card__title-text _v-29212bf6=\"\">{{title}}</h4> </div> <div class=\"mdl-card__supporting-text scrollbar\" _v-29212bf6=\"\"> {{{text}}} </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-29212bf6!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/segments/FAQ.vue
// module id = 346
// module chunks = 0